"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgRewindOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.rewind_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "rewind_outline_svg__transparent_box" },
            React.createElement("path", { className: "rewind_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "rewind_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("path", { d: "M16 15.4V7.33L-.11 16 16 24.67v-8.06l15 8.06V7.33zm-2 5.93L4.11 16 14 10.67zm15 0L19.1 16l9.9-5.33z", id: "rewind_outline_svg__OUTLINE" })));
}
exports.default = SvgRewindOutline;
//# sourceMappingURL=RewindOutline.js.map